export enum PRIZE_TYPE {
    SPIN_AGAIN = 'Spin Again',
    PRIZE_100 = '$100 Prize',
    PRIZE_50 = '$50 Prize',
    VOGUE_VIP = 'Vogue VIP',
    MAJOR = 'Major Prize',
    LUCKY_DIP = 'Lucky Dip'
}
